import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '@environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AIAgentService {
    constructor(private http: HttpClient) { }

    askQuestion(question: string): Observable<any> {
        return this.http.post<any>(`${environment.serviceApi}/aiagent/ask`, { prompt: question });
    }
}